import { render, staticRenderFns } from "./userGuideAndFormsDisplay.vue?vue&type=template&id=da53148c&scoped=true&"
import script from "./userGuideAndFormsDisplay.vue?vue&type=script&lang=js&"
export * from "./userGuideAndFormsDisplay.vue?vue&type=script&lang=js&"
import style0 from "./userGuideAndFormsDisplay.vue?vue&type=style&index=0&id=da53148c&lang=scss&scoped=true&"
import style1 from "./userGuideAndFormsDisplay.vue?vue&type=style&index=1&id=da53148c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da53148c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da53148c')) {
      api.createRecord('da53148c', component.options)
    } else {
      api.reload('da53148c', component.options)
    }
    module.hot.accept("./userGuideAndFormsDisplay.vue?vue&type=template&id=da53148c&scoped=true&", function () {
      api.rerender('da53148c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/userGuideAndFormsDisplay.vue"
export default component.exports